

/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 协议编号 */
    id: 'taxNumber',

    /** 手机号码 */
    tel: 'mobile',

    /** 姓名 */
    name: 'registerUserName',

    /** 身份证正面 */
    IDUrl: 'idCardPositiveUrl',

    /** 身份证反面 */
    IDReverseUrl: 'idCardOtherSideUrl',

    /** 委托书 */
    proxyFileUrl: 'taxCommissionUrl',

    /** 申请时间 */
    applyTime: 'taxApplyTime',

    /** 开通时间 */
    openingTime: 'taxPassTime',

    /** 状态 */
    state: 'taxStatus',
    stateDesc: 'taxStatusDesc'

};

/** 状态 */
export const Status = {
    /** 申请中 */
    NEW: 'NEW',

    /** 已开通 */
    PASS: 'PASS',

    /** 申请失败 */
    OVERRULE: 'OVERRULE'
};

export const OperateType = {
    /** 通过 */
    BASH_PASS: 'BASH_PASS',

    /** 驳回 */
    BASH_OVERRULE: 'BASH_OVERRULE'
}
